import { ApiService } from './apiService'

interface Config {
  api: {
    osmosisBaseUrl: string
  }
  agentKey: string
  gaMeasurementId: string
  sentryDsn: string
  envName: string
  selfservicePanelBaseUrl: string
}

interface FeatureFlagResponse {
  enabled: boolean
  flagKey: string
}

export class WebEnvironmentConfigService {
  private config: Config | null = null
  private configPromise: Promise<Config> | null = null

  private async loadConfig(): Promise<Config> {
    if (this.config) return this.config
    if (this.configPromise) return this.configPromise

    this.configPromise = fetch('/config.json')
      .then((response) => response.json())
      .then((config) => {
        this.config = config
        return config
      })
      .catch(() => {
        return {
          api: {
            osmosisBaseUrl: 'http://localhost:3000',
          },
          agentKey: 'A-0013', // TODO: Change by Karla UserName
          gaMeasurementId: 'G-6VR8CV0FEB',
          sentryDsn:
            'https://a4f09ec27d5994d0df9361055dec9799@o4510042370867200.ingest.us.sentry.io/4510584778719232',
          envName: 'development',
          selfservicePanelBaseUrl: 'https://selfservicepanel.mutuus.click',
        }
      })

    return this.configPromise
  }

  async getApiBaseUrl(): Promise<string> {
    const config = await this.loadConfig()
    return config.api.osmosisBaseUrl
  }

  async getDefaultGeneralAgentKey(): Promise<string> {
    const config = await this.loadConfig()
    return config.agentKey
  }

  async getFeatureFlagValue(featureFlagName: string): Promise<boolean> {
    try {
      const apiService = new ApiService()
      const response = await apiService.get<FeatureFlagResponse>(
        `/feature-flags/${featureFlagName}`,
      )
      return response.enabled === true
    } catch (error) {
      console.error('Hubo un error: Error fetching feature flag ', error)
      return false
    }
  }

  async getGaMeasurementId(): Promise<string> {
    const config = await this.loadConfig()
    return config.gaMeasurementId
  }

  async getSentryDsn(): Promise<string> {
    const config = await this.loadConfig()
    return config.sentryDsn
  }

  async getEnvironmentName(): Promise<string> {
    const config = await this.loadConfig()
    return config.envName
  }

  async getSelfservicePanelBaseUrl(): Promise<string> {
    const config = await this.loadConfig()
    return config.selfservicePanelBaseUrl
  }
}
